export const arr =[
    {key:"Hurricane percy",value:"Ouragan Percy"},
    {key:"I like plus size women cause sometimes when I kiss slender women there’s this funny aftertaste of bones.",value:"J'aime les femmes rondes parce que parfois, quand j'embrasse des femmes minces, il y a ce drôle d'arrière-goût d'os."},
    {key:"Mjikijelwa",value:"Mjikijelwa"},
    {key:"I love alcohol. A lot of people tell me it won’t take me anywhere. Who said I’m trying to go somewhere?",value:"J'adore l'alcool. Beaucoup de gens me disent que ça ne me mènera nulle part. Qui a dit que j'essayais d'aller quelque part ?"},
    {key:"Thulani mcking",value:"Thulani mcking"},
    {key:"I wrote a joke about Pizza and it’s a good one if I have to say so myself. Now I just have to work on its delivery.",value:"J'ai écrit une blague sur la pizza, et elle est excellente, je dois le dire. Il ne me reste plus qu'à m'occuper de sa réalisation."},
    {key:"Zicco",value:"Zicco"},
    {key:"I got a tattoo done on my private parts. Now my girlfriend is complaining that I like putting words in her mouth.",value:"Je me suis fait tatouer les parties intimes. Maintenant, ma copine se plaint que j'aime bien lui faire dire ce que je n'ai pas dit."},
    {key:"Hurrican percy",value:"Ouragan Percy"},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},
    {key:"",value:""},


  
]